import { request } from '@umijs/max';

export interface DrawMessageListParams {
  status?: number;
  page?: number;
  aa?: string;
  ap?: string;
  am?: string;
  class?: number;
}

export async function fetchDrawMessages(params: DrawMessageListParams) {
  return request<any>('/oms/me/draw/messages', {
    method: 'GET',
    params,
  });
}

export async function fetchDrawMessageCount() {
  return request<any>('/oms/me/draw/messages/count', {
    method: 'GET',
  });
}
